import React from 'react'
import { Link } from 'react-router-dom'

function Nav() {
  
  window.onload = () => {
    slideOutMobile()
  }
  
  window.addEventListener(`resize`, () => {
    let viewport_width = window.innerWidth
    
    if (viewport_width >= 1280) {
      slideIn()
    } else {
      slideOut()
    }
  })
  
  function showHideNavMenu() {
    if (document.getElementById(`menu-nav`).style.left === `-270px`) {
      slideIn()
    } else {
      slideOut()
    }
  }
  
  function slideOutMobile() {
    let viewport_width = window.innerWidth
    
    if (viewport_width < 1280) {
      slideOut()
    }
  }
 
  function slideIn() {
    document.getElementById(`menu-nav`).style.left = `0px`
    document.getElementById(`menu-button`).style.width = `260px`
  }
 
  function slideOut() {
    document.getElementById(`menu-nav`).style.left = `-270px`
    document.getElementById(`menu-button`).style.width = `64px`
  }
  
  return (
    <nav>
      <button id="menu-button" onClick={showHideNavMenu}>&equiv;</button>
      
      <div id="menu-nav">
        <ul>
          <li><Link to="/" onClick={slideOutMobile}>Home</Link></li>
          <li><Link to="/videos" onClick={slideOutMobile}>Videos</Link></li>
          <li><Link to="/listen" onClick={slideOutMobile}>Listen</Link></li>
          <li><Link to="/exclusive" onClick={slideOutMobile}>Exclusive</Link></li>
          <li><Link to="/unreleased" onClick={slideOutMobile}>Unreleased</Link></li>
          <li><Link to="/social" onClick={slideOutMobile}>Social</Link></li>
        </ul>
      </div>
    </nav>
  )
}

export default Nav